import { BinaryMime, MimeType, TextualMime, VirtualFileLike } from '@rxap/fs';

export class HttpFile implements VirtualFileLike {
  public mimetype?: MimeType;

  get data(): Promise<ArrayBuffer> {
    if (!this._dataPromise) {
      const data =
        typeof this.dataFactory === 'function'
          ? this.dataFactory()
          : this.dataFactory;
      this._dataPromise = data.then((data) => {
        this._byteLength = data.byteLength;
        return data;
      });
    }
    return this._dataPromise;
  }
  private _textContent: string | null = null;
  private _blob: Blob | null = null;
  private _byteLength: number | null = null;

  private _dataPromise: Promise<ArrayBuffer> | null = null;

  constructor(
    public readonly name: string,
    public readonly fullName: string,
    protected readonly dataFactory:
      | Promise<ArrayBuffer>
      | (() => Promise<ArrayBuffer>),
    protected readonly existsFactory:
      | Promise<boolean>
      | (() => Promise<boolean>) = Promise.resolve(true)
  ) {}

  async getContent(mimetype: TextualMime): Promise<string>;
  async getContent(mimetype: BinaryMime): Promise<Blob>;
  async getContent(mimetype?: MimeType): Promise<string | Blob>;
  async getContent(
    mimetype: MimeType = this.mimetype ?? 'auto'
  ): Promise<string | Blob> {
    let blob: Blob;
    if (this._blob?.type === mimetype) {
      blob = this._blob;
    } else {
      const data = await this.data;
      this._blob = blob = new Blob([data], { type: mimetype });
    }
    if (
      mimetype.startsWith('text/') ||
      mimetype.endsWith('xml') ||
      mimetype.endsWith('json')
    ) {
      if (!this._textContent) {
        const data = await this.data;
        this._textContent = new TextDecoder().decode(data);
      }
      return this._textContent;
    }
    return blob;
  }

  setMimeType(mimetype: string) {
    this.mimetype = mimetype;
  }

  async toFile(useFullName = false): Promise<File> {
    const data = await this.data;
    return new File([data], useFullName ? this.fullName : this.name, {
      type: this.mimetype,
    });
  }

  exists(): Promise<boolean> {
    if (typeof this.existsFactory == 'function') {
      return this.existsFactory();
    }
    return this.existsFactory;
  }

  toJSON() {
    return {
      mimetype: this.mimetype,
      byteLength: this._byteLength,
    };
  }
}
